import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

type EraYearsType = "CE" | "BE";

@customElement("pg-random-generator")
export class PGDRandomGenerator extends LitElement {
  @property({ type: String }) EraYears: EraYearsType = "CE";
  @property({ type: String }) labelButton = "Generate Code";
  @property({ type: String }) bgColorBtn = "#2196F3";
  @property({ type: String, attribute: "value" }) public value = "";

  generateCode(event: Event) {
    event.preventDefault();
    let yearPart;
    if (this.EraYears === "CE") {
      yearPart = new Date().getFullYear().toString();
    } else {
      yearPart = (new Date().getFullYear() + 543).toString();
    }
    const randomPart = this.makeid(4);
    const generatedCode = `${yearPart}-${randomPart}`;
    this.value = generatedCode;
    this.setAttribute("value", generatedCode);
    this.requestUpdate();
  }

  makeid(length: number) {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
  }

  updateBgColor() {
    this.style.setProperty("--pg-btn-bg-color", this.bgColorBtn);
  }

  updated(changedProperties: Map<string | number | symbol, unknown>) {
    super.updated(changedProperties);
    if (changedProperties.has("bgColorBtn")) {
      this.updateBgColor();
    }
  }

  render() {
    return html`
      <div class="random-container">
        <input part="randomInput" id="code" type="text" name="input" disabled .value=${this.value} />
        <button part="randomButton" class="btn btn-random" @click=${(e: Event) => this.generateCode(e)}>${this.labelButton}</button>
      </div>
    `;
  }

  static styles = css`
    :host {
      display: inline-block;
      width: 100%;
      --btn-bg-color: var(--pg-btn-bg-color, "#2196F3");
    }
    input[type="text"] {
      display: block;
      width: 70%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      font-weight: 400;
      line-height: 1.5;
      color: #212529;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border-radius: 0.375rem;
      transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
      outline-color: rgba(82, 168, 236, 0.8);
    }
    .random-container {
      display: flex;
      flex-direction: row;
      gap: 10px;
    }
    .btn-random {
      display: flex;
      width: 30%;
      color: #fff;
      background-color: var(--btn-bg-color);
      border: 1px solid #ced4da;
      border-radius: 8px;
      padding: 10px 15px;
      align-items: center;
      justify-content: center;
      min-width: 95px;
      cursor: pointer;
    }
    .btn-random:hover {
      opacity: 0.8;
    }
  `;
}
